<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useAuthStore } from '@/stores/auth'

  const { handleLogin } = useAuthStore()

  onMounted(() => handleLogin())
</script>

<template>
  <router-view />
</template>

<style>
  #app {
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: "header"
      "main"
      "footer";
    min-height: 100vh;
  }

  header {
    grid-area: header;
  }

  main {
    grid-area: main;
    min-height: 0;
  }

  footer {
    grid-area: footer;
  }
</style>
